import apiConfig from "../../apiConfig";
export const setDepartmentServiceTemplatesSigns = async (
	at,
	departmentServiceVersionId,
	templateId,
	userSignState,
	reviewSignState,
	approvalSignState,
	QRCodeState,
	QRCode_Sign_Type_Id,
	QRCode_Sign_Pages
) => {
	const response = await apiConfig.post(
		"/API/ADMINISTRATION/DEPARTMENTS/SERVICES/UPDATE_DEPARTMENT_SERVICE_TEMPLATE_SIGNS",
		{
			Department_Service_Version_Id: departmentServiceVersionId,
			Template_Id: templateId,
			Enable_User_Sign: userSignState,
			Enable_Review_Sign: reviewSignState,
			Enable_Approval_Sign: approvalSignState,
			Enable_QR_Code: QRCodeState,
			QRCode_Sign_Type_Id,
			QRCode_Sign_Pages,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
